import React from 'react';
import './login.css';
import closedEye from '../../assets/closedEye.svg';
import openEye from '../../assets/openedEye.svg';
import { t } from 'i18next';
import { Input } from '../../components/Input';
import { Button } from '../../components/Button/index';
import { XIMI_LOGIN_SELECT_ACCOUNT_PATH } from '../../routePaths';
import { XIMI_LOGIN_ENABLED } from '../../config';

interface LoginFormProps {
    setDisplayPage: (t: 'login' | 'singup' | 'forgot') => void;
    login: (email: string, pass: string) => void;
    isLoggingIn?: boolean;
}

export function LoginForm({
    setDisplayPage,
    login,
    isLoggingIn = false
}: LoginFormProps): JSX.Element {
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [showPassword, setShowPassword] = React.useState(false);

    return (
        <>
            <h3>{t('Bonjour 👋')}</h3>
            <h5>{t('Saisissez vos informations de connexion')}</h5>
            <form
                id="login-form"
                name="login-form"
                onSubmit={(e) => e.preventDefault()}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        login(email, password);
                    }
                }}>
                <Input
                    sxRoot={{ paddingBottom: '0.5rem', width: '100%' }}
                    label="Email"
                    type="email"
                    placeholder="ex : jean.dupont@hotmail.com"
                    value={email}
                    onChange={(val: string) => setEmail(val)}
                    autoComplete="off"
                />
                <Input
                    sxRoot={{ paddingBottom: '0.5rem', width: '100%' }}
                    label={t('Mot de passe') ?? ''}
                    placeholder="********"
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(val: string) => setPassword(val)}
                    imgIntoInput={showPassword ? openEye : closedEye}
                    btnAriaLabel={
                        (showPassword
                            ? t('Masquer le mot de passe')
                            : t('Afficher le mot de passe')) ?? ''
                    }
                    btnClick={() => setShowPassword(!showPassword)}
                    autoComplete="off"
                />
                <div className="button-group">
                    <Button
                        label={
                            isLoggingIn ? t('Connexion en cours...') ?? '' : t('Me connecter') ?? ''
                        }
                        theme="PRIMARY"
                        fullWidth
                        disabled={isLoggingIn}
                        action={() => login(email, password)}
                    />
                    <Button
                        label={t('Activer mon accès') ?? ''}
                        theme="SECONDARY"
                        fullWidth
                        action={() => setDisplayPage('singup')}
                    />
                </div>
                <p id="login-forgot-password" onClick={() => setDisplayPage('forgot')}>
                    {t('Mot de passe oublié ?')}
                </p>
                {XIMI_LOGIN_ENABLED && (
                    <>
                        <div className="login-separator">
                            <span>{t('ou')}</span>
                        </div>
                        <Button
                            label={t('Connexion Ximi') ?? ''}
                            theme="GREY"
                            fullWidth
                            action={XIMI_LOGIN_SELECT_ACCOUNT_PATH}
                        />
                    </>
                )}
                <p className="login-policies">
                    <span>{t('En vous connectant, vous acceptez les ')}</span>
                    <a href="https://appv1.stimulin.fr/cgu.html" target="_blank" rel="noreferrer">
                        {t("conditions générales d'utilisation")}
                    </a>
                    <span>{t(' et ')}</span>
                    <a
                        href="https://appv1.stimulin.fr/politique-de-confidentialite.html"
                        target="_blank"
                        rel="noreferrer">
                        {t('politique de confidentialité')}
                    </a>
                    <span>{t(" de Stimul'in.")}</span>
                </p>
            </form>
        </>
    );
}
